import { TextButton } from "@/components/ui/pressable";
import { ArrowDown, ArrowUp } from "lucide-react";
import { useListContext } from "ra-core";
import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";

type SortableTableHeadProps = {
  field: string;
  label: string;
  className?: string;
  /** Text alignment of the header (numbers sit right). */
  align?: "left" | "right";
  /** Order on the first click (e.g. newest first for dates). */
  defaultOrder?: "ASC" | "DESC";
};

/** Clickable table header that toggles ASC/DESC via ra-core list sort. */
export const SortableTableHead = ({
  field,
  label,
  className,
  align = "left",
  defaultOrder = "ASC",
}: SortableTableHeadProps) => {
  const { sort, setSort } = useListContext();
  const active = sort?.field === field;
  const order = active ? sort.order : "ASC";

  return (
    <TableHead
      className={cn(
        "text-muted-foreground",
        align === "right" && "text-right",
        className,
      )}
      aria-sort={
        active ? (order === "ASC" ? "ascending" : "descending") : undefined
      }
    >
      <TextButton
        size="xs"
        className={cn(
          "h-8 uppercase tracking-wide",
          align === "right" && "ml-auto flex",
          active && "text-foreground",
        )}
        onClick={() =>
          setSort({
            field,
            order: active ? (order === "ASC" ? "DESC" : "ASC") : defaultOrder,
          })
        }
      >
        {label}
        {active ? (
          order === "ASC" ? (
            <ArrowUp className="opacity-70" />
          ) : (
            <ArrowDown className="opacity-70" />
          )
        ) : null}
      </TextButton>
    </TableHead>
  );
};
